<template>
    <div>
        <div>
            <div class="card">
                <div class="tw-flex tw-justify-between">
                    <h2 class="card-title tw-justify-start tw-uppercase">
                        <span>📅</span>
                        {{ $t("loanRepayment.repaymentHistory") }}
                    </h2>
                </div>
                <div class="overflow-auto">
                    <div class="demo-spin-article">
                        <div style="height:37.2vh">
                            <table class="schedule-table">
                                <thead class="schedule-header">
                                    <tr>
                                        <th width="15%">
                                            {{ $t("loanRepayment.dueDate") }}
                                        </th>
                                        <th width="15%">
                                            {{
                                                $t(
                                                    "loanRepayment.actualpaymentDate"
                                                )
                                            }}
                                        </th>
                                        <th width="10%" class="tw-text-center">
                                            {{
                                                $t(
                                                    "loanRepayment.rescueFeePaid"
                                                )
                                            }}
                                        </th>
                                        <th width="10%" class="tw-text-center">
                                            {{
                                                $t("loanRepayment.rescueFeeDue")
                                            }}
                                        </th>
                                        <th width="10%" class="tw-text-center">
                                            {{
                                                $t(
                                                    "loanRepayment.monthlyFeePaid"
                                                )
                                            }}
                                        </th>
                                        <th width="10%" class="tw-text-center">
                                            {{
                                                $t(
                                                    "loanRepayment.monthlyFeeDue"
                                                )
                                            }}
                                        </th>
                                        <th class="tw-text-center" width="10%">
                                            {{
                                                $t("loanRepayment.interestPaid")
                                            }}
                                        </th>
                                        <th class="tw-text-center" width="10%">
                                            {{
                                                $t("loanRepayment.interestDue")
                                            }}
                                        </th>
                                        <th width="10%" class="tw-text-center">
                                            {{
                                                $t(
                                                    "loanRepayment.principalPaid"
                                                )
                                            }}
                                        </th>
                                        <th width="10%" class="tw-text-center">
                                            {{
                                                $t("loanRepayment.principalDue")
                                            }}
                                        </th>
                                        <th class="tw-text-center" width="15%">
                                            {{
                                                $t("loanRepayment.amountRepay")
                                            }}
                                        </th>
                                        <th class="tw-text-center" width="15%">
                                            {{ $t("loanRepayment.balance") }}
                                        </th>
                                        <th width="15%" class="text-center">
                                            {{ $t("loanRepayment.isOwe") }}
                                        </th>
                                        <th class="text-center" width="10%">
                                            {{ $t("loanRepayment.isConfirm") }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="isRepaymentSchedules">
                                    <tr
                                        v-for="(row,
                                        index) in loan.loan_repayments"
                                        :key="index"
                                        class="schedule-row"
                                    >
                                        <td class="tw-whitespace-nowrap">
                                            {{ row.cycle_payment_date }}
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            {{ row.actual_payment_date }}
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.interest_paid,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.interest_due,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.principal_paid,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.principal_due,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.monthly_fee_paid,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.monthly_fee_due,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.rescue_fee_paid,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.rescue_fee_due,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.actual_payment_amount,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.outstanding_balance,
                                                        loan.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td
                                            class="tw-whitespace-nowrap tw-text-center"
                                        >
                                            <span
                                                class="text-warning"
                                                v-if="row.is_owe_cycle_paid"
                                                >{{ $t("yes") }}</span
                                            >
                                            <span
                                                v-else
                                                class="text-success"
                                                >{{ $t("no") }}</span
                                            >
                                        </td>
                                        <td
                                            class="text-center tw-whitespace-nowrap tw-justify-items-center tw-items-center"
                                        >
                                            <span
                                                class="text-success"
                                                v-if="row.is_approved"
                                                >{{ $t("yes") }}</span
                                            >
                                            <span
                                                v-else
                                                class="text-secondary"
                                                >{{ $t("no") }}</span
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Spin size="large" fix v-if="scheduleLoading"> </Spin>
                </div>

                <!-- <div class="summary-stats">
                    <div class="stat-item">
                        <div class="stat-value">
                            {{ signBycurrencyId(edit_data.currency_id)
                            }}{{
                                formatNumber(
                                    totalPrincipal,
                                    edit_data.currency_id
                                )
                            }}
                        </div>
                        <div class="stat-label">
                            {{ $t("loanDisbursement.totalPrincipal") }}
                        </div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-value">
                            {{ signBycurrencyId(edit_data.currency_id)
                            }}{{
                                formatNumber(
                                    totalInterest,
                                    edit_data.currency_id
                                )
                            }}
                        </div>
                        <div class="stat-label">
                            {{ $t("loanDisbursement.totalInterest") }}
                        </div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-value">
                            {{ signBycurrencyId(edit_data.currency_id)
                            }}{{
                                formatNumber(totalFee, edit_data.currency_id)
                            }}
                        </div>
                        <div class="stat-label">
                            {{ $t("loanDisbursement.totalFees") }}
                        </div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-value">
                            {{ signBycurrencyId(edit_data.currency_id)
                            }}{{
                                formatNumber(
                                    totalAmountRepay,
                                    edit_data.currency_id
                                )
                            }}
                        </div>
                        <div class="stat-label">
                            {{ $t("loanDisbursement.finalAmount") }}
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    name: "repaymentHistory",
    props: ["value"],
    data() {
        return {
            model: {},
            scheduleLoading: false,
            pdf_view: false
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        ...mapState("creditOperation/loanRepayment", ["loanDisbursements"]),
        ...mapGetters(["formatNumber", "signBycurrencyId"]),
        loan() {
            if (this.loanDisbursements.length > 0 && this.model.loan_id) {
                return this.loanDisbursements.find(
                    l => l.loan_id == this.model.loan_id
                );
            }
            return [];
        },
        currency() {
            if (this.model.loan_id) {
                return this.loan.currency;
            }
            return {
                currency_id: this.$store.state.authUser.sys_setting[0]
                    .default_currency_id,
                currency_code: this.$store.state.authUser.sys_setting[0]
                    .default_currency
            };
        },
        isRepaymentSchedules() {
            if (this.model.loan_id) {
                return true;
            }
            return false;
        },
        totalPrincipalPaid() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return parseFloat(
                        this.loan.loan_repayments
                            .reduce(
                                (n, { principal_paid }) => n + principal_paid,
                                0
                            )
                            .toFixed(4)
                    );
                }
                return 0;
            }
            return 0;
        },
        totalPrincipalDue() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return parseFloat(
                        this.loan.loan_repayments
                            .reduce(
                                (n, { principal_due }) => n + principal_due,
                                0
                            )
                            .toFixed(4)
                    );
                }
                return 0;
            }
            return 0;
        },
        totalMonthlyFeePaid() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return parseFloat(
                        this.loan.loan_repayments
                            .reduce(
                                (n, { monthly_fee_paid }) =>
                                    n + monthly_fee_paid,
                                0
                            )
                            .toFixed(4)
                    );
                }
                return 0;
            }
            return 0;
        },
        totalMonthlyFeeDue() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return parseFloat(
                        this.loan.loan_repayments
                            .reduce(
                                (n, { monthly_fee_due }) => n + monthly_fee_due,
                                0
                            )
                            .toFixed(4)
                    );
                }
                return 0;
            }
            return 0;
        },
        totalInterestPaid() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return parseFloat(
                        this.loan.loan_repayments
                            .reduce(
                                (n, { interest_paid }) => n + interest_paid,
                                0
                            )
                            .toFixed(4)
                    );
                }
                return 0;
            }
            return 0;
        },
        totalInterestDue() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return parseFloat(
                        this.loan.loan_repayments
                            .reduce(
                                (n, { interest_due }) => n + interest_due,
                                0
                            )
                            .toFixed(4)
                    );
                }
                return 0;
            }
            return 0;
        },
        totalRescueFeePaid() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return parseFloat(
                        this.loan.loan_repayments
                            .reduce(
                                (n, { rescue_fee_paid }) => n + rescue_fee_paid,
                                0
                            )
                            .toFixed(4)
                    );
                }
                return 0;
            }
            return 0;
        },
        totalAmountRepay() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return parseFloat(
                        this.loan.loan_repayments
                            .reduce(
                                (n, { actual_payment_amount }) =>
                                    n + actual_payment_amount,
                                0
                            )
                            .toFixed(4)
                    );
                }
                return 0;
            }
            return 0;
        },
        totalNumberOfPayment() {
            if (this.isRepaymentSchedules) {
                if (this.loan.length > 0) {
                    return this.loan.loan_repayments.length;
                }
                return 0;
            }
            return 0;
        }
    }
};
</script>
<style scoped>
.card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    padding: 15px;
    backdrop-filter: blur(20px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.card-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #333;
}

/* Payment Schedule */
.schedule-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

.schedule-header {
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: white;
}

.schedule-header th {
    padding: 6px 2px;
    font-weight: 600;
    font-size: 11px;
    position: sticky;
    top: 0;
    z-index: 1;
    white-space: nowrap;
}

.schedule-row {
    transform: scale(1);
    transition: transform 0.2s ease;
}
.schedule-row td {
    padding: 6px;
    border-bottom: 1px solid #f1f5f9;
    font-size: 13px;
}

.schedule-row:hover {
    background: #f8fafc;
    transform: scale(1.01);
    transition: transform 0.2s ease;
}

.amount-cell {
    font-weight: 600;
    color: #059669;
}

.balance-cell {
    font-weight: 600;
    color: #dc2626;
}

/* Animations */
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.card {
    animation: slideIn 0.6s ease-out;
}

.summary-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px;
    margin-top: 10px;
}

.stat-item {
    text-align: center;
    padding: 10px;
    background: #f8fafc;
    border-radius: 12px;
}

.stat-value {
    font-size: 20px;
    font-weight: 700;
    color: #667eea;
}

.stat-label {
    font-size: 12px;
    color: #64748b;
    margin-top: 4px;
}
</style>
